import "./Home.css"
import React from "react"
import me from "../me.jpg"

export default function Home() {
    return (
        <div  className="homeContainer">
            <div className="leftHalf">
                <div className="homeImgContainer">
                <img src={me} alt="code background" className="homeImg"></img>
                </div>
            </div>
            <div className="rightHalf">
                <h1>Hello, I'm Lucas Castelli,</h1>
                <p className="homeP">A frontend-focused full stack web developer new to the game.</p>
                <p className="homeP">I'm eager to begin my journey into the world of development and show what I've learned so far as I continue to expand my skill set.</p>
            </div>
            
        </div>
    )
}